interface DistBarDatum {
  band: string;
  /** Share of the whole, 0–100. Rendered directly — no count-over-total math. */
  pct: number;
}

interface DistBarProps {
  data: DistBarDatum[];
}

/**
 * A horizontal distribution bar — e.g. the anonymized share of agents per income
 * band. Segments use the sequential teal ramp (applied inline because the index is
 * computed at runtime). Carries no per-row dollar figures by design.
 */
const seq = (i: number) => `hsl(var(--chart-seq-${Math.min(5, 2 + i)}))`;

const DistBar = ({ data }: DistBarProps) => (
  <div>
    <div className="flex h-4 overflow-hidden rounded-pill border border-border">
      {data.map((d, i) => (
        <div key={i} style={{ width: `${d.pct}%`, background: seq(i) }} title={`${d.band} · ${d.pct}%`} />
      ))}
    </div>
    <div className="mt-3.5 flex flex-wrap gap-x-[18px] gap-y-2">
      {data.map((d, i) => (
        <span key={i} className="inline-flex items-center gap-[7px] text-[12.5px] text-ink-700">
          <span className="h-2.5 w-2.5 rounded-[3px]" style={{ background: seq(i) }} />
          {d.band} <span className="font-semibold tabular-nums text-ink-900">{d.pct}%</span>
        </span>
      ))}
    </div>
  </div>
);

export default DistBar;
